"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDynamicColumnsList = void 0;
const hooks_1 = require("../../../../ui/hooks");
const utils_1 = require("../../../../ui/utils");
const swr_1 = __importDefault(require("swr"));
function useDynamicColumnsList(request) {
    const dynamicColumnClient = (0, hooks_1.useDynamicColumnClient)();
    const mappedStorageRequest = Object.assign(Object.assign({}, request.filterData), { offset: request.offset, limit: request.limit });
    const response = (0, swr_1.default)(['dynamicColumnList', mappedStorageRequest], (_a) => __awaiter(this, [_a], void 0, function* ([, request]) {
        return dynamicColumnClient.listColumns(request);
    }), {
        use: [utils_1.laggy],
        revalidateOnFocus: false,
    });
    return Object.assign(Object.assign({}, response), { data: response.data
            ? {
                rows: response.data.rows,
                filteredRowCount: response.data.total,
            }
            : undefined, reload: response.mutate });
}
exports.useDynamicColumnsList = useDynamicColumnsList;
